import React from "react";
import "../../css/designSystem/Footer.css";
import { useNavigate } from "react-router-dom";
import Map from "../../assets/images/Map.jpg";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <img
        src={Map}
        alt="Map"
        className="footer-map"
        onClick={() =>
          window.open(
            "https://www.google.com/maps/place/WPP+Financial+Services/@51.3474047,0.5073837,17z/data=!3m1!5s0x47d8ccd304d36bf1:0x5467cb836a27890c!4m6!3m5!1s0x47d8cdef0249f371:0x2367658a8a285780!8m2!3d51.3474047!4d0.5073837!16s%2Fg%2F11gw26qwxn?entry=ttu&g_ep=EgoyMDI2MDQwNy4wIKXMDSoASAFQAw%3D%3D",
            "_blank",
          )
        }
      />
      <div className="footer-top">
        <div className="footer-columns">
          <div className="content grey">
            If you are not happy with our service, please write to Complaints
            Officer, Rosemount Financial Solutions (IFA) Limited, Rosemount House,
            2-4 Chequers Road, Basingstoke, RG21 7PU. Telephone
            <a href="tel:01256405460" className="footer-link">
              {" "}
              01256 405460
            </a>{" "}
            or e-mail{" "}
            <a
              href="mailto:complaints@rosemountfs.co.uk"
              className="footer-link"
            >
              complaints@rosemountfs.co.uk
            </a>
          </div>
          <div className="content grey">
            A summary of our internal complaints handling procedures for the
            reasonable and prompt handling of complaints is available on request
            and if you cannot settle your complaint with us, you may be entitled
            to refer it to the financial Ombudsman Service at{" "}
            <a
              href="https://www.financial-ombudsman.org.uk"
              className="footer-link"
            >
              www.financial-ombudsman.org.uk
            </a>{" "}
            or by contacting them on
            <a href="tel:08000234567" className="footer-link">
              0800 023 4567
            </a>
            .
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-columns">
          <div
            className="content-semibold underline"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </div>
          <div className="content">
            WPP Financial Services Limited is an Appointed Representative of
            Rosemount Financial Solutions (IFA) Limited which is authorised and
            regulated by the Financial Conduct Authority (FCA).  Entered on the
            FCA Register (https://register.fca.org.uk/) under reference 535515.
            WPP Financial Services Limited is registered in England and Wales,
            number 08925832.  Registered Address:  Innovation Centre Medway,
            Maidstone Road, Chatham, United Kingdom,{" "}
            <span style={{ whiteSpace: "nowrap" }}>ME5 9FD</span>.
          </div>
          <div className="content">
            The information contained within this website is subject to the UK
            regulatory regime, and is therefore targeted at consumers based in
            the UK.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
